window.addEventListener('DOMContentLoaded', () => {
  const openAccessibilityPanel = document.querySelectorAll('.open-accessibility-panel')
  openAccessibilityPanel.forEach((panel) => {
    panel.addEventListener('click', () => {
      const userwayPanel = document.querySelector('.userway_p1')
      if (!userwayPanel) return
      if(userwayPanel.classList.contains('userway-on')) {
        userwayPanel.classList.remove('userway-on')
      } else {
        userwayPanel.classList.add('userway-on')
        document.querySelector('.ui_w')?.click()
      }
    })
  })
})
